import { HeaderDesktop } from '../header-desktop/header-desktop';
import { HeaderMobile } from '../header-mobile/header-mobile';

class Header {
  private desktop: HeaderDesktop;
  private mobile: HeaderMobile;

  constructor() {
    this.desktop = new HeaderDesktop();
    this.mobile = new HeaderMobile();
  }
}

export const header = new Header();
